<template>
    <div id="formUser">
        <v-dialog v-model="showForm" scrollable max-width="700">
            <v-card>
                <v-toolbar card prominent color="primary" dark>
                    <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="cancelForm()">
                        <v-icon medium>fa fa-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-flex>
                    <div slot="widget-content">
                        <v-alert
                            v-model="showErrorDataLoadedAlert"
                            type="error"
                            dismissible
                            transition="scale-transition"
                            dark
                        >
                            No se han podido cargar todos los datos necesarios para este formulario, intente cargar el
                            formulario nuevamente.
                        </v-alert>
                    </div>
                </v-flex>

                <v-card-text>
                    <v-form ref="userForm" v-model="isValidUser">
                        <v-text-field
                            v-model="user.name"
                            label="Usuario*"
                            :rules="userNameRules"
                            :error-messages="userNameErrors"
                            @blur="userNameErrors = []"
                        >
                        </v-text-field>

                        <v-text-field v-model="user.first_name" label="Nombre"> </v-text-field>

                        <v-text-field v-model="user.last_name" label="Apellidos"> </v-text-field>

                        <v-text-field
                            v-model="user.email"
                            label="Email*"
                            :rules="userEmailRules"
                            :error-messages="userEmailErrors"
                            @blur="userEmailErrors = []"
                        >
                        </v-text-field>

                        <v-text-field
                            v-if="!initialItem"
                            v-model="user.password"
                            label="Password*"
                            :type="showPassword ? 'text' : 'password'"
                            :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                            @click:append="showPassword = !showPassword"
                            :rules="userPasswordRules"
                            :error-messages="userPasswordErrors"
                            @blur="userPasswordErrors = []"
                        >
                        </v-text-field>

                        <v-text-field
                            v-if="!initialItem"
                            v-model="user.confirm_password"
                            label="Confirmar password*"
                            :type="showConfPassword ? 'text' : 'password'"
                            :append-icon="showConfPassword ? 'visibility_off' : 'visibility'"
                            @click:append="showConfPassword = !showConfPassword"
                            :rules="[userConfirmPasswordRule, passwordConfirmationRule]"
                            :error-messages="userConfirmPasswordErrors"
                        >
                        </v-text-field>
                    </v-form>

                    <!-- Gestión de roles -->
                    <v-card tile>
                        <v-toolbar card color="white" class="mt-3">
                            <v-toolbar-title class="subheading grey--text text--darken-1">Asignaciones</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!-- Formulario de roles -->
                            <v-dialog v-model="assignmentDialog" persistent max-width="500">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" :disabled="loading">
                                        <v-icon medium>fa fa-plus</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title class="title">Asignar rol</v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text>
                                        <v-form ref="assignmentForm" v-model="isValidAssignment">
                                            <v-flex xs12 sm6 d-flex>
                                                <v-select
                                                    v-model="rolField"
                                                    :items="ROLES"
                                                    item-text="description"
                                                    item-value="name"
                                                    :rules="rolFieldRules"
                                                    chips
                                                    required
                                                    label="Rol*"
                                                    return-object
                                                >
                                                </v-select>
                                            </v-flex>
                                        </v-form>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="grey darken-1" flat @click="closeAssignmentForm()"
                                            >Cancelar
                                        </v-btn>
                                        <v-btn
                                            color="green darken-1"
                                            flat
                                            @click="addAssignment()"
                                            :disabled="!isValidAssignment"
                                            >Guardar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <!-- Termina Formulario de roles -->
                        </v-toolbar>

                        <v-divider></v-divider>

                        <!-- Comienza tabla de asignaciones -->
                        <v-data-table :headers="assignmentHeaders" :items="assignments" hide-actions>
                            <template slot="items" slot-scope="props">
                                <td>{{ props.item.name }}</td>
                                <td>{{ props.item.description }}</td>
                                <td class="text-xs-right">
                                    <v-btn
                                        depressed
                                        icon
                                        flat
                                        color="red"
                                        @click="deleteAssignment(props.item)"
                                        :disabled="loading"
                                    >
                                        <v-icon medium>fa fa-trash</v-icon>
                                    </v-btn>
                                </td>
                            </template>
                            <template slot="no-data">
                                <div style="text-align: center">
                                    No existen asignaciones para este usuario.
                                </div>
                            </template>
                        </v-data-table>
                        <!-- Termina tabla de asignaciones -->
                    </v-card>
                    <!-- Termina Gestión de roles -->
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <small class="ml-2">(*) indica campos requeridos</small>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="menu" width="350" transition="slide-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-if="!isNewRecord"
                                :disabled="loading"
                                flat
                                round
                                small
                                outline
                                color="orange"
                                class="white--text"
                                v-on="on"
                                @click="newPassword = ''"
                            >
                                Cambiar contraseña
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-text pb-0>
                                <v-form ref="passwordForm" v-model="isValidNewPassword">
                                    <v-text-field
                                        v-model="newPassword"
                                        label="Nueva contraseña"
                                        :append-icon="showTextPassword ? 'visibility' : 'visibility_off'"
                                        :type="showTextPassword ? 'text' : 'password'"
                                        :rules="userPasswordRules"
                                        @click:append="showTextPassword = !showTextPassword"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                        v-model="newPasswordConfirm"
                                        label="Confirmar contraseña"
                                        :append-icon="showTextConfirm ? 'visibility' : 'visibility_off'"
                                        :type="showTextConfirm ? 'text' : 'password'"
                                        :rules="[userConfirmPasswordRule, newPasswordConfirmationRule]"
                                        @click:append="showTextConfirm = !showTextConfirm"
                                    >
                                    </v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="red" flat @click="menu = false">
                                    Cancelar
                                </v-btn>
                                <v-btn
                                    @click="savePassword"
                                    color="success"
                                    :disabled="!isValidNewPassword"
                                    :loading="loading"
                                    flat
                                >
                                    Ok
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                    <v-btn color="success" flat @click="saveForm()" :disabled="disableSaveButton" :loading="loading"
                        >Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    name: "UserForm",
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null }
    },

    data: () => ({
        loading: false,

        // Formulario de usuario
        isValidUser: true,
        loadingUser: false,
        userField: null,
        user: {
            name: null,
            first_name: null,
            last_name: null,
            email: null,
            password: "",
            confirm_password: ""
        },

        //mostrar contrasena
        showPassword: false,
        showConfPassword: false,

        //menu de nueva contrasena
        menu: false,
        isValidNewPassword: false,
        newPassword: "",
        newPasswordConfirm: "",
        showTextPassword: false,
        showTextConfirm: false,

        //validaciones
        userNameRules: [
            v => !!v || "Debe proporcionar un nombre de usuario.",
            v => /^[a-z]\w*$/.test(v) || "El usuario no cumple los requisitos de complejidad."
        ],
        userNameErrors: [],
        userEmailRules: [
            v => !!v || "Debe proporcionar un correo.",
            // eslint-disable-next-line no-useless-escape
            v =>
                /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
                    v
                ) || "Debe proporcionar un email válido "
        ],
        userEmailErrors: [],
        userPasswordRules: [
            v => !!v || "Debe proporcionar una contraseña.",
            v => v.length >= 6 || "La contraseña debe tener al menos 6 caracteres"
        ],
        userPasswordErrors: [],
        userConfirmPasswordRule: v => !!v || "Debe confirmar la contraseña anterior.",
        userConfirmPasswordErrors: [],

        // Formulario de asignaciones
        assignmentDialog: false,
        isValidAssignment: false,
        rolField: [],
        rolFieldRules: [v => !!v || "Debe seleccionar un rol."],

        // Lista de roles por organización
        assignments: [],
        assignmentHeaders: [
            { text: "Rol", value: "name", sortable: false },
            { text: "Descripción", value: "description", sortable: false },
            { sortable: false }
        ],

        //saber si se cargaron todos los datos necesarios para el formulario
        showErrorDataLoadedAlert: false
    }),

    computed: {
        ...mapGetters(["ROLES", "USER_ROLES"]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || this.assignments.length === 0 || !this.isValidUser
        },

        passwordConfirmationRule() {
            if (this.user.password !== "" && this.user.confirm_password !== "") {
                return (
                    this.user.password === this.user.confirm_password ||
                    "La contraseña proporcionada no coincide con la anterior"
                )
            } else return true
        },

        newPasswordConfirmationRule() {
            if (this.newPassword !== "" && this.newPasswordConfirm !== "") {
                return (
                    this.newPassword === this.newPasswordConfirm ||
                    "La contraseña proporcionada no coincide con la anterior"
                )
            } else return true
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.userForm.validate()
            if (this.isValidUser) {
                var user = {
                    username: this.user.name,
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    email: this.user.email,
                    roles: this.assignments.map(role => role.name)
                }
                if (this.isNewRecord) {
                    user.password = this.user.password
                } else {
                    user.id = this.initialItem.id
                }

                this.$store.dispatch(this.isNewRecord ? "ADD_USER" : "UPDATE_USER", user).then(result => {
                    if (!result) {
                        //no hay coneccion con el servidor
                        this.loading = false
                    }
                    if (result === null || result.status === 404 || result.status === 500) {
                        //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                        this.$emit("formCanceled")
                    } else {
                        // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                        let { data, status } = result
                        if (status === 422) {
                            data.forEach(error => {
                                switch (error.field) {
                                    case "username":
                                        this.userNameErrors.push(error.message)
                                        break
                                    case "email":
                                        this.userEmailErrors.push(error.message)
                                        break
                                    case "password":
                                        this.userPasswordErrors.push(error.message)
                                        break
                                    //ToDo: capturar los errores provenientes de las asignaciones de roles
                                }
                            })
                        }
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        },

        cancelForm() {
            this.$emit("formCanceled")
        },

        addAssignment() {
            this.$refs.assignmentForm.validate()
            if (this.isValidAssignment) {
                let assignment = {
                    name: this.rolField.name,
                    description: this.rolField.description
                }

                let exists = this.assignments.findIndex(el => el.name === assignment.name)
                if (exists === -1) {
                    this.assignments.push(assignment)
                }
                this.closeAssignmentForm()
            }
        },

        deleteAssignment(item) {
            this.assignments = this.assignments.filter(el => el.name !== item.name)
        },

        closeAssignmentForm() {
            this.isValidAssignment = true
            this.rolField = null
            this.assignmentDialog = false
        },

        savePassword() {
            this.loading = true
            if (this.newPassword.length > 5) {
                var user = {
                    id: this.initialItem.id,
                    username: this.user.name,
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    email: this.user.email,
                    roles: this.assignments.map(role => role.name),

                    password: this.newPassword
                }

                this.$store.dispatch("UPDATE_USER_PASSWORD", user).then(result => {
                    if (!result) {
                        //no hay coneccion con el servidor
                        this.loading = false
                    }
                    if (result === null || result.status === 404 || result.status === 500) {
                        //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                        this.menu = false
                        this.$emit("formCanceled")
                    } else {
                        // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                        let { data, status } = result
                        if (status === 422) {
                            data.forEach(error => {
                                switch (error.field) {
                                    case "username":
                                        this.userNameErrors.push(error.message)
                                        break
                                    case "email":
                                        this.userEmailErrors.push(error.message)
                                        break
                                    case "password":
                                        this.userPasswordErrors.push(error.message)
                                        break
                                    //ToDo: capturar los errores provenientes de las asignaciones de roles
                                }
                            })
                        }
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        }
    },

    created() {
        this.$store.dispatch("LOAD_ROLES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.initialItem !== null) {
            // Cargando información del elemento a actualizar
            this.user.name = this.initialItem.username
            this.user.first_name = this.initialItem.first_name
            this.user.last_name = this.initialItem.last_name
            this.user.email = this.initialItem.email
            this.assignments = this.initialItem.roles
        }
    }
}
</script>
